// Handler générique [data-anim] — remplace AOS.
// Pattern gsap.set + gsap.to (jamais gsap.from) : robuste au ScrollTrigger.refresh().
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ANIM, DATA_ANIM_STATES } from "./anim_config";

gsap.registerPlugin( ScrollTrigger );

export function initDataAnim( scope = document ) {
    const els = scope.querySelectorAll( "[data-anim]:not(.is-animated)" );

    els.forEach( ( el ) => {
        const name     = el.dataset.anim;
        const delay    = parseFloat( el.dataset.delay )    || 0;
        const duration = parseFloat( el.dataset.duration ) || ANIM.duration.md;
        const start    = el.dataset.start || ANIM.start.section;
        const once     = el.dataset.once !== "false";

        const initial = DATA_ANIM_STATES[ name ];
        if ( ! initial ) return;

        gsap.set( el, initial );

        const final = {};
        Object.keys( initial ).forEach( ( k ) => {
            if ( k === "opacity" ) {
                final[ k ] = 1;
            } else if ( k === "filter" ) {
                final[ k ] = "blur(0px)";
            } else if ( k === "scale" ) {
                final[ k ] = 1;
            } else {
                final[ k ] = 0;
            }
        } );

        const play = () => gsap.to( el, {
            ...final,
            duration,
            delay,
            ease: ANIM.ease.out,
            clearProps: "transform,opacity,filter",
            onComplete: () => el.classList.add( "is-animated" ),
        } );

        // Déjà dans le viewport au chargement : on anime tout de suite.
        const rect = el.getBoundingClientRect();
        if ( rect.top < window.innerHeight && rect.bottom > 0 ) {
            play();
        } else {
            ScrollTrigger.create( { trigger: el, start, once, onEnter: play } );
        }
    } );
}
